/*
  SANA — ouverture du mega-menu au survol (desktop uniquement).
  - Hover sur un item parent : ouvre son mega-menu, ferme instantanément les autres.
  - Quitter la zone (titre + panneau) : fermeture après un court délai pour éviter
    les fermetures accidentelles entre le titre et le panneau.
  - Clic souris sur le titre : navigation vers data-url (le toggle natif est conservé
    pour le clavier, les lecteurs d'écran et le tactile).
*/
(function () {
  var HOVER_DESKTOP = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var CLOSE_DELAY = 150;

  function initHeaderMenu(headerMenu) {
    var details = headerMenu.querySelector('details.mega-menu');
    if (!details) return;
    var summary = details.querySelector('summary');
    if (!summary) return;

    var closeTimer = null;

    function setOpen(target, open) {
      var targetSummary = target.querySelector('summary');
      if (open) {
        if (!target.hasAttribute('open')) target.setAttribute('open', '');
        if (targetSummary) targetSummary.setAttribute('aria-expanded', 'true');
      } else {
        if (target.hasAttribute('open')) target.removeAttribute('open');
        if (targetSummary) targetSummary.setAttribute('aria-expanded', 'false');
      }
    }

    headerMenu.addEventListener('mouseenter', function () {
      if (!HOVER_DESKTOP.matches) return;
      window.clearTimeout(closeTimer);
      // Switch propre : ferme immédiatement tout autre mega-menu ouvert.
      document.querySelectorAll('header-menu details.mega-menu[open]').forEach(function (other) {
        if (other !== details) setOpen(other, false);
      });
      setOpen(details, true);
    });

    headerMenu.addEventListener('mouseleave', function () {
      if (!HOVER_DESKTOP.matches) return;
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        setOpen(details, false);
      }, CLOSE_DELAY);
    });

    summary.addEventListener('click', function (event) {
      if (!HOVER_DESKTOP.matches) return;
      // Activation clavier / lecteur d'écran : conserver le toggle natif.
      if (event.detail === 0) return;
      // Tap tactile sur écran hybride : conserver le toggle natif.
      if (event.pointerType === 'touch' || event.pointerType === 'pen') return;

      var url = summary.getAttribute('data-url');
      if (!url || url === '#') return;

      event.preventDefault();
      if (event.metaKey || event.ctrlKey) {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    });
  }

  function init() {
    document.querySelectorAll('header-menu').forEach(initHeaderMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
